import { useState } from "react";
import { useSelector } from "react-redux";
import {
  ListingToolBar,
  ListingViewToggle,
  LISTING,
  GRID,
} from "@ten24/slatwall-storefront-react-private/global";

import { useListing } from "../../hooks/components/Listing/useListing";
import { useElementContext } from "@ten24/slatwall-storefront-react-private/global";

import { ListingGrid } from "../Listing/ListingGrid";
import { ListingListView } from "../Listing/ListingListView";
import { SearchPreFilter } from "./SearchPreFilter";
import { ListingPagination } from "../Listing/ListingPagination";

const SearchListingStack = ({ initPreFilter = {}, hide = "", showFilterSidebar, ...props }) => {
  const { ListingSidebar } = useElementContext();
  const defaultListingConfig = useSelector((state) => state.configuration.defaultListingConfig);
  const [preFilter] = useState(initPreFilter);
  const searchConfig = JSON.parse(props?.listingConfig) || defaultListingConfig;
  const searchListingData = useListing(preFilter, searchConfig);
  const {
    records,
    isFetching,
    potentialFilters,
    total,
    totalPages,
    setSort,
    updateAttribute,
    setPage,
    setKeyword,
    params,
  } = searchListingData;
  const [viewMode, setViewMode] = useState(searchConfig.viewMode || LISTING);
  // const [selectedOption, setSelectedOption] = useState({});

  const showForcedPreFilters = !!searchConfig?.requiredPreFilters?.find((filter) => !searchListingData?.params[filter]);

  const cardDisplayConfigurations = {
    skuCardConfiguration: JSON.parse(props?.skuCardConfiguration),
    productCardConfiguration: JSON.parse(props?.productCardConfiguration),
  };

  if (showForcedPreFilters) {
    return (
      <div className="container cetSearchPreFilter">
        {searchConfig?.requiredPreFilters?.map((filter, idx) => {
          return (
            <SearchPreFilter
              key={idx}
              params={searchListingData.params}
              potentialFilters={searchListingData.potentialFilters}
              requiredFilterSlug={filter}
            />
          );
        })}
      </div>
    );
  }

  return (
    <div className="container product-listing mb-5 py-2">
      <ListingToolBar
        config={searchConfig}
        {...potentialFilters}
        removeFilter={updateAttribute}
        setSort={setSort}
        recordsCount={total}
      />
      <ListingViewToggle config={searchConfig} viewMode={viewMode} setViewMode={setViewMode} />
      <div className="row mt-3">
        {(showFilterSidebar || showFilterSidebar !== false) && (
          <ListingSidebar
            config={searchConfig}
            isFetching={isFetching}
            hide={hide}
            filtering={potentialFilters}
            recordsCount={total}
            keyword={params["keyword"]}
            setKeyword={setKeyword}
            updateAttribute={updateAttribute}
          />
        )}
        <div className="col">
          {viewMode === LISTING && (
            <ListingListView
              cardDisplayConfigurations={cardDisplayConfigurations}
              config={searchConfig}
              isFetching={isFetching}
              pageRecords={records}
            />
          )}
          {viewMode === GRID && (
            <ListingGrid
              cardDisplayConfigurations={cardDisplayConfigurations}
              config={searchConfig}
              isFetching={isFetching}
              pageRecords={records}
            />
          )}
        </div>
      </div>
      <ListingPagination
        recordsCount={total}
        currentPage={params["currentPage"]}
        totalPages={totalPages}
        setPage={setPage}
      />
    </div>
  );
};

export { SearchListingStack };
